import DividerPipe from './DividerPipe'

export default DividerPipe
